/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_1_Item_2_DetailInputs */

const en_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eight consecutive years (2002 through 2008)`)
};

const es_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocho años consecutivos (2002 a 2008)`)
};

const de_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acht Jahre in Folge (2002 bis 2008)`)
};

const zh_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连续八年（2002 年至 2008 年）`)
};

const ar_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ثماني سنوات متتالية (من 2002 إلى 2008)`)
};

const fr_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huit années consécutives (2002 à 2008)`)
};

const vi_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tám năm liên tiếp (2002 đến 2008)`)
};

const sw_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miaka minane mfululizo (2002 hadi 2008)`)
};

const th_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แปดปีติดต่อกัน (2002 ถึง 2008)`)
};

const bs_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osam uzastopnih godina (od 2002. do 2008.)`)
};

const ja_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8年連続（2002年～2008年）`)
};

const ko_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8년 연속 (2002년~2008년)`)
};

const pt_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oito anos consecutivos (2002 a 2008)`)
};

const it_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otto anni consecutivi (dal 2002 al 2008)`)
};

const sv_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åtta år i följd (2002 till 2008)`)
};

const nl_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acht opeenvolgende jaren (2002 tot en met 2008)`)
};

const da_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otte år i træk (2002 til 2008)`)
};

const nb_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åtte år på rad (2002 til 2008)`)
};

const fi_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kahdeksan peräkkäistä vuotta (2002–2008)`)
};

const pl_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osiem kolejnych lat (2002–2008)`)
};

const ru_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Восемь лет подряд (2002–2008)`)
};

const tr_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekiz ardışık yıl (2002–2008)`)
};

const hi_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लगातार आठ साल (2002 से 2008)`)
};

const id_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delapan tahun berturut-turut (2002 sampai 2008)`)
};

const ms_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lapan tahun berturut-turut (2002 hingga 2008)`)
};

const cs_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osm po sobě jdoucích let (2002 až 2008)`)
};

const el_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Οκτώ συνεχόμενα έτη (2002 έως 2008)`)
};

const he_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שמונה שנים רצופות (2002 עד 2008)`)
};

const af_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agt agtereenvolgende jare (2002–2008)`)
};

const hu_about_content_honor_1_item_2_detail = /** @type {(inputs: About_Content_Honor_1_Item_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyolc egymást követő évben (2002–2008)`)
};

/**
* | output |
* | --- |
* | "Eight consecutive years (2002 through 2008)" |
*
* @param {About_Content_Honor_1_Item_2_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_1_item_2_detail = /** @type {((inputs?: About_Content_Honor_1_Item_2_DetailInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_1_Item_2_DetailInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_1_item_2_detail(inputs)
	if (locale === "de") return de_about_content_honor_1_item_2_detail(inputs)
	if (locale === "zh") return zh_about_content_honor_1_item_2_detail(inputs)
	if (locale === "ar") return ar_about_content_honor_1_item_2_detail(inputs)
	if (locale === "fr") return fr_about_content_honor_1_item_2_detail(inputs)
	if (locale === "vi") return vi_about_content_honor_1_item_2_detail(inputs)
	if (locale === "sw") return sw_about_content_honor_1_item_2_detail(inputs)
	if (locale === "th") return th_about_content_honor_1_item_2_detail(inputs)
	if (locale === "bs") return bs_about_content_honor_1_item_2_detail(inputs)
	if (locale === "ja") return ja_about_content_honor_1_item_2_detail(inputs)
	if (locale === "ko") return ko_about_content_honor_1_item_2_detail(inputs)
	if (locale === "pt") return pt_about_content_honor_1_item_2_detail(inputs)
	if (locale === "it") return it_about_content_honor_1_item_2_detail(inputs)
	if (locale === "sv") return sv_about_content_honor_1_item_2_detail(inputs)
	if (locale === "nl") return nl_about_content_honor_1_item_2_detail(inputs)
	if (locale === "da") return da_about_content_honor_1_item_2_detail(inputs)
	if (locale === "nb") return nb_about_content_honor_1_item_2_detail(inputs)
	if (locale === "fi") return fi_about_content_honor_1_item_2_detail(inputs)
	if (locale === "pl") return pl_about_content_honor_1_item_2_detail(inputs)
	if (locale === "ru") return ru_about_content_honor_1_item_2_detail(inputs)
	if (locale === "tr") return tr_about_content_honor_1_item_2_detail(inputs)
	if (locale === "hi") return hi_about_content_honor_1_item_2_detail(inputs)
	if (locale === "id") return id_about_content_honor_1_item_2_detail(inputs)
	if (locale === "ms") return ms_about_content_honor_1_item_2_detail(inputs)
	if (locale === "cs") return cs_about_content_honor_1_item_2_detail(inputs)
	if (locale === "el") return el_about_content_honor_1_item_2_detail(inputs)
	if (locale === "he") return he_about_content_honor_1_item_2_detail(inputs)
	if (locale === "af") return af_about_content_honor_1_item_2_detail(inputs)
	if (locale === "hu") return hu_about_content_honor_1_item_2_detail(inputs)
	return en_about_content_honor_1_item_2_detail(inputs)
});